<main role="main" class="not-home-page">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner"><img src="" alt="" /></div>
          <app-breadcrumb></app-breadcrumb>
          <h2>{{ "PlanSite" | translate }}</h2>
        </div>
        <div class="col-md-3 side-bar">
          <div class="selected-item">      </div>
          <nav id="sidebar">
            <app-statique-menu
              [lg]="currentLg"
              [cururl]="'/acces-rapide/plan-site'"
            ></app-statique-menu>
          </nav>
        </div>
        <div style="padding-left:20px" class="col-md-9">
          <section class="content-side">
            <div class="container">
              <div class="row">
                <div class="col-lg-10 col-md-10 col-s-12">
                  <div class="row">
                    <div
                      class="col-lg-3 col-md-3 col-s-12"
                      style="padding-bottom: 30px"
                      *ngFor="let item of MenuNiveau0"
                    >
                      <a
                        class="PrimaryLink"
                        href="javascript:void(0)"
                        [routerLink]="['/' + item.ApplicationUrl]"
                        routerLinkActive="router-link-active"
                      >
                        {{ item.Title }}
                      </a>
                      <ul class="ulLink">
                        <li [class.liLink]="currentLg.code!='ar'" [class.liLinkar]="currentLg.code=='ar'" *ngFor="let Sitem of getSousMenu(item.Id)"
                        
                        [class.ar-arrow]="currentLg.code=='ar'">
                            <a
                            class="SecondaryLink"
                            href="javascript:void(0)"
                            [routerLink]="['/' + Sitem.ApplicationUrl]"
                            routerLinkActive="router-link-active"
                          >
                          {{ Sitem.Title }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</main>
